import React from 'react';
import { valuePillars } from '../../data/capabilities';
import { SectionHeading } from '../SectionHeading';
export function ValueProposition() {
  return <section id="value" className="w-full bg-paper py-20 lg:py-28" data-id="element-154" data-mp="2o1uliwrl33df">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-155" data-mp="31y86ifvbtmwn">
        <SectionHeading title="Strategic Value Proposition & Board Competencies" intro="What a board gets in the seat, stated plainly." data-id="element-156" data-mp="2xy7fzwuydl98" />

        <ol className="mt-14 border-t border-line" data-id="element-157" data-mp="2a691z544dbse">
          {valuePillars.map(pillar => <li key={pillar.label} className="grid grid-cols-1 gap-3 border-b border-line py-8 lg:grid-cols-12 lg:gap-12" data-id="element-158" data-mp="2575vdg8hqxib">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-600 lg:col-span-4 lg:pt-1.5" data-id="element-159" data-mp="2e8vw5co9j8sr">
                {pillar.label}
              </p>
              <p className="font-display text-xl leading-snug text-navy-900 lg:col-span-8 lg:text-2xl" data-id="element-160" data-mp="1mj0uqhn4rsnq">
                {pillar.statement}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}